import { useId } from "react";
import { useContextValues } from "../../context/RouteDataContext.jsx";
import TypeaheadSelect from "../TypeaheadSelect.jsx";

export default function StopsFilter({ inputId, label = "Customize table stops" }) {
  const { availableStops, selectedStops, setSelectedStops } = useContextValues();
  const generatedInputId = useId().replace(/:/g, "");
  const selectInputId = inputId || `stops-filter-${generatedInputId}`;

  const stopOptions = availableStops.map((stop) => (
    {
      value: stop.stop_id,
      label: `${stop.stop_name}`,
    }));

  return (
    <TypeaheadSelect
      id={selectInputId}
      label={label}
      options={stopOptions}
      value={selectedStops}
      onChange={setSelectedStops}
      isMulti
      placeholder="Select all that apply"
      className="mt-auto"
    />
  );
}
